import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "data-preview"
}
const _hoisted_2 = { class: "preview-item" }
const _hoisted_3 = { class: "icon-box" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, "今日总访问量", -1)
const _hoisted_5 = { class: "value-box" }
const _hoisted_6 = { class: "value" }
const _hoisted_7 = { class: "compare" }
const _hoisted_8 = { class: "preview-item" }
const _hoisted_9 = { class: "icon-box" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, "今日新增用户量", -1)
const _hoisted_11 = { class: "value-box" }
const _hoisted_12 = { class: "value" }
const _hoisted_13 = { class: "compare" }
const _hoisted_14 = { class: "preview-item preview-yellow" }
const _hoisted_15 = { class: "icon-box" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, "本月订单总额", -1)
const _hoisted_17 = { class: "value-box" }
const _hoisted_18 = { class: "value" }
const _hoisted_19 = { class: "compare" }
const _hoisted_20 = { class: "preview-item preview-red" }
const _hoisted_21 = { class: "icon-box" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, "程序异常警告", -1)
const _hoisted_23 = { class: "value-box" }
const _hoisted_24 = { class: "value" }
const _hoisted_25 = { class: "compare" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "visits-box" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "近14天访问量"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "visits-chart",
    id: "VisitsChart"
  })
], -1)
const _hoisted_27 = { class: "module-half" }
const _hoisted_28 = { class: "item-box" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "近 30 天订单金额", -1)
const _hoisted_30 = {
  class: "orders-chart",
  id: "OrdersChart"
}
const _hoisted_31 = { class: "empty" }
const _hoisted_32 = { class: "icon" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("p", { class: "text" }, "暂无订单配置", -1)
const _hoisted_34 = { class: "item-box" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "未读消息", -1)
const _hoisted_36 = { class: "message-box" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { class: "type-box" }
const _hoisted_39 = { class: "info-box" }
const _hoisted_40 = { class: "name" }
const _hoisted_41 = { class: "info" }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = { class: "empty" }
const _hoisted_44 = { class: "icon" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("p", { class: "text" }, "暂无未读消息", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_elem_icon = _resolveComponent("elem-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: "home-page",
    id: "HomePage",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClickPage && _ctx.onClickPage(...args))),
    "dark-class": "home-page-dark"
  }, [
    (_ctx.info)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_elem_icon, { name: "visits" })
            ]),
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.info.visitsToday), 1),
              _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.getCompare(_ctx.info.visitsCompare)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_elem_icon, { name: "add_user" })
            ]),
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.info.usersToday), 1),
              _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.getCompare(_ctx.info.usersCompare)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_elem_icon, { name: "order" })
            ]),
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.info.orderToday), 1),
              _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.getCompare(_ctx.info.orderCompare)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_component_elem_icon, { name: "exception" })
            ]),
            _hoisted_22,
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.info.exceptionsToday), 1),
              _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.getCompare(_ctx.info.exceptionsCompare)), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _hoisted_26,
    _createElementVNode("div", _hoisted_27, [
      _createElementVNode("div", _hoisted_28, [
        _hoisted_29,
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _createVNode(_component_elem_icon, {
                width: "18px",
                height: "18px",
                src: "static/interactive/icon/",
                name: "info",
                dark: "info_dark"
              })
            ]),
            _hoisted_33
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_34, [
        _hoisted_35,
        _createElementVNode("div", _hoisted_36, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (item, idx) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "message-item",
              key: idx,
              onClick: ($event: any) => (_ctx.onJumpMessagePage(item.uuid))
            }, [
              _createElementVNode("div", _hoisted_38, [
                _createVNode(_component_elem_icon, {
                  width: "25px",
                  height: "25px",
                  src: "static/interactive/icon/",
                  name: _ctx.getMessageIcon(item.type),
                  dark: _ctx.getMessageIcon(item.type, true)
                }, null, 8, ["name", "dark"])
              ]),
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("div", _hoisted_40, _toDisplayString(item.source.title), 1),
                _createElementVNode("div", _hoisted_41, _toDisplayString(item.message), 1)
              ]),
              _createElementVNode("div", {
                class: "more",
                onClick: _withModifiers(($event: any) => (_ctx.onDeleteMessage(item.uuid)), ["stop"])
              }, [
                _createVNode(_component_elem_icon, {
                  name: "close",
                  dark: "close_white"
                })
              ], 8, _hoisted_42)
            ], 8, _hoisted_37))
          }), 128)),
          _withDirectives(_createElementVNode("div", _hoisted_43, [
            _createElementVNode("div", _hoisted_44, [
              _createVNode(_component_elem_icon, {
                width: "18px",
                height: "18px",
                src: "static/interactive/icon/",
                name: "success",
                dark: "success_dark"
              })
            ]),
            _hoisted_45
          ], 512), [
            [_vShow, _ctx.messages && _ctx.messages.length <= 0]
          ])
        ])
      ])
    ])
  ]))
}